import React from 'react';

import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "./entity-header.module.scss";
import {EntityLogo} from "../logos/entity-logo";
import {Link} from "../link/link";

export const EntityHeader = observer(({entity, title, className, onClick}) => {
  const {name} = entity;
  const label: String = title || name;

  const linkProps = {
    className: classNames(styles.header_button, className),
    model: entity.linkModel,
    onClick
  }

  const entityLogoProps = {
    className: classNames(styles.logo),
    entity,
    width: 24,
    height: 24,
  };

  return (
    <Link {...linkProps}>
      <EntityLogo {...entityLogoProps}/>
      <div className={classNames(styles.competition)}>{label}</div>
    </Link>
  );
});

